import service, { serviceGo } from "@/utils/request";
import type { AxiosRequestConfig } from "axios";

/** 附加自定义标记的请求配置：_silentError = 跳过全局兜底弹窗，由调用方自行读 err.response.data.message */
type RoleRequestConfig = AxiosRequestConfig & { _silentError?: boolean }


export interface RoleAlias {
  name: string
  start_node_id: number | null
  end_node_id: number | null
}

export interface Role {
  id?: number
  game_id: number
  name: string
  aliases: RoleAlias[] // 角色别名列表（遗留字段，不再使用）
  avatar_url: string
  bio: string
  personality: string
  dialogue_style: string
  role_type: string,
  voice_type: string,
  initial_states: Record<string, number> // 如 { mood: 50, trust: 30 }
  need_affection: boolean // 是否启用好感度系统
  show_banner: boolean // 是否展示在 app
  show_cos: number // 是否展示在衣橱，0=不展示，1=展示
  show_intr: boolean // 是否在客户端"角色介绍"页中展示
  display_name: string // 读者端「角色介绍」页展示的名字；空 = 使用角色名称
  parent_role_id: number | null // 父角色ID，非空表示该角色共享父角色的属性
  child_role_ids: number[] // 子角色ID列表
}

// 获取全部角色
export async function getRoles(gameId: number): Promise<Role[]> {
  const resp = await service.get('/api/roles/', {params: {"game_id": gameId}})
  return resp.data
}

// 获取单个角色
export async function getRole(id: number): Promise<Role> {
  const resp = await service.get(`/api/roles/${id}`)
  return resp.data
}

// 创建角色。config 可传 { _silentError: true } 跳过全局兜底弹窗、自行展示后端 message
export async function createRole(data: Role, config?: RoleRequestConfig): Promise<any> {
  const resp = await service.post('/api/roles/', data, config)
  return resp.data
}

// 更新角色。config 同 createRole
export async function updateRole(id: number, data: Role, config?: RoleRequestConfig): Promise<any> {
  const resp = await service.put(`/api/roles/${id}`, data, config)
  return resp.data
}

// 删除角色
export async function deleteRole(id: number): Promise<any> {
  const resp = await service.delete(`/api/roles/${id}`)
  return resp.data
}

export async function getVoiceType(): Promise<any> {
  const resp = await service.get(`/api/roles/voice_type`)
  return resp.data
}

export async function testVoice(voiceType: string, roleName: string): Promise<any> {
  const resp = await serviceGo.post('/api_v2/tts/test', {
    voice_type: voiceType,
    role: roleName
  })
  return resp.data
}